import { useMutation } from "@tanstack/react-query";
import TenantHandler from "../handlers/tenant";

const useTenantMonthlyGrowth = (onSuccess, onFailure, onPending) => {
	const tenantHandler = new TenantHandler();

	const { data, isSuccess, isError, error, mutate } = useMutation({
		mutationFn: (payload) => tenantHandler.getTenantMontlyGrowth(payload),
		onSuccess: onSuccess,
		onError: onFailure,
		onMutate: onPending,
	});

	return { data, isSuccess, isError, error, mutate };
};

export default useTenantMonthlyGrowth;
